import clsx from "clsx";
import moment from "moment";
import { Button } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import { BsCalculator, BsCalendar3 } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import { AiOutlineApi, AiOutlineDelete } from "react-icons/ai";
import {
  DollarCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Col,
  Collapse,
  DatePicker,
  Descriptions,
  Divider,
  List,
  message,
  Modal,
  Row,
  Skeleton,
  Space,
  Spin,
  Tooltip,
  Typography,
} from "antd";
import apis from "../../services/apis";
import { Page } from "../../constants/brokers";
import AntButton from "../../components/Button";
import { PayTags } from "../Darf/Components/PayTags";
import { useAuth } from "../../contexts/AuthContext";
import { FormModal } from "../../components/FormModal";
import { useBroker } from "../../contexts/BrokerContext";
import { StyledTag } from "../Darf/Components/PayTags/styles";
import { Container, Content, BolsaOperations } from "./styles";
import { IntegrationModal } from "../Darf/Components/IntegrationModal";
import {
  DatePickerMonthCell,
  YearResume,
} from "../Darf/Components/DatePickerMonthCell";
import { DatePickerExtraFooter } from "../Darf/Components/DatePickerExtraFooter";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import { PaymentModal } from "../../components/PaymentModal";

import {
  DarfModal,
  DarfResultDescriptions,
  minDarfPrice,
  maxDarfPrice,
  IDarfBolsa,
  defaultDarfBolsa,
  DarfBolsaFormItemRows,
  PrejuFormItemRows,
  YearResumeStatusCSSClassEnum,
  YearResumeStatusTextEnum,
  YearResumeStatusColorEnum,
  YearResumeStatusFromBackEnum,
  DarfBolsaTabs,
  IrrfFormItemRows,
} from "../../constants/darfBolsa";
import {
  antDatePickerLocale,
  download,
  errorMessage,
  formatCurrency,
  monthsExtended,
} from "../../utils";
import { apiPayment } from "../../services/apiPayment";

interface DarfBolsaProps {
  item: Page;
  view?: boolean;
  darf?: {
    id: string;
  };
}

export const DarfBolsa: React.FC<DarfBolsaProps> = ({ view, item, darf }) => {
  const { user, showUserPlanModal, userPlanModal, updateUserInfo } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { currentBroker, currentPage } = useBroker();
  const today = new Date();
  const queryYear = (state as any)?.year;
  const queryMonth = (state as any)?.month;
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  const maxPixPayment = 10000;
  const maxCreditCardPayment = 10000;

  const initialMonth = queryMonth
    ? queryMonth - 1
    : today.getMonth() - 1 >= 0
      ? today.getMonth() - 1
      : 11;
  const initialYear = queryYear
    ? queryYear
    : today.getMonth() - 1 >= 0
      ? today.getFullYear()
      : today.getFullYear() - 1;
  const defaultValue = moment({ month: initialMonth, year: initialYear });
  const currentDate = moment({
    month: currentMonth,
    year: currentYear,
  }).subtract(1, "M");
  window.history.replaceState({}, document.title);

  const [asset, setAsset] = useState<any>();
  const [loading, setLoading] = useState(false);

  const [emitting, setEmitting] = useState(false);
  const [darfModal, setDarfModal] = useState<any>();
  const [helpModal, setHelpModal] = useState<any>();
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState<IDarfBolsa>();
  const [year, setYear] = useState(initialYear);
  const [month, setMonth] = useState(initialMonth);
  const [data, setData] = useState<IDarfBolsa>(defaultDarfBolsa);
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [yearResume, setYearResume] = useState<YearResume[]>([]);
  const [gettingYearResume, setGettingYearResume] = useState(false);
  const [notAuthorized] = useState(false);
  const [showNotAuthorizedModal, setShowNotAuthorizedModal] = useState(false);

  const [historicoActiveKey, setHistoricoActiveKey] = useState("");
  const [impostoActiveKey, setImpostoActiveKey] = useState("");

  const userPlanInfoStatus = useMemo(
    () => user.user.userPlanInfoVelotax,
    [user.user.userPlanInfoVelotax]
  );

  const valorPrincipal = Math.max(
    0,
    Number(
      (data.impostoComumFinal || 0) +
      (data.impostoDTFinal || 0) +
      (data.impostoFIIFinal || 0)
    ) +
    (Number(data["impostoAcumulado"] || 0) - Number(data["irrfTotal"] || 0))
  );
  const impostoCharge = useMemo(() => {
    return (
      valorPrincipal +
      (valorPrincipal < minDarfPrice
        ? 0
        : (data.multaAux ?? 0) + (data.jurosAux ?? 0))
    );
  }, [data, valorPrincipal]);

  const transactionFeature = item.features[0];
  const taxFeature = item.features[1];
  const yearResumeFeature = item.features[2];
  const prejuizoFeature = item.features[3];
  const irrfFeature = item.features[4];

  const { emitted, status } = useMemo(() => {
    if (gettingYearResume) {
    }
    const monthResume = yearResume
      .find((resume) => resume.year === year)
      ?.months.find((m) => m.month - 1 === month);
    return {
      emitted:
        monthResume?.status === YearResumeStatusFromBackEnum.PAYED ||
        monthResume?.status === YearResumeStatusFromBackEnum.NOT_PAYED,
      payed: !!monthResume?.payed,
      status: monthResume?.status,
    };
  }, [yearResume, year, month, gettingYearResume]);

  const handleLabelButton: ReactNode = useMemo(() => {
    // if (!userPlanInfoStatus) return "Assinar Plano Emissão de DARF";

    if ((data?.impostoTotalFinal || 0) <= maxDarfPrice) return "Pagar DARF";
    else {
      if (emitted) return "Emitir novo DARF";
      else return taxFeature?.buttonLabel;
    }
  }, [data?.impostoTotalFinal, taxFeature?.buttonLabel, emitted]);

  const getDarf = useCallback(
    (id: string) => {
      view && setLoading(true);
      view &&
        (currentPage?.api || apis)
          .get(`${taxFeature.apiUrl}/${id}`)
          .then((response) => {
            setYear(response.data?.year);
            setMonth(response.data?.month - 1);
            setData({
              ...response.data,
              emitted: true,
            });
          })
          .catch((err) => {
            message.error(err.response?.data?.message || errorMessage);
          })
          .finally(() => setLoading(false));
    },
    [view, taxFeature.apiUrl, currentPage]
  );

  const getYearResume = useCallback(
    (year: number, force?: boolean, url?: string) => {
      setGettingYearResume(true);
      !view &&
        year <= new Date().getFullYear() &&
        year >= moment(`2020-01-01`).get("year") &&
        (force ||
          (!yearResumeFeature.disabled &&
            !yearResume.find((resume) => resume.year === year))) &&
        (currentPage?.api || apis)
          .get(yearResumeFeature.apiUrl, { params: { year } })
          .then((response) => {
            const index = yearResume.findIndex(
              (resume) => resume.year === year
            );
            if (index >= 0) {
              setYearResume((yearResume) => {
                yearResume.splice(index, 1, response.data);
                return yearResume;
              });
            } else {
              setYearResume((yearResume) => [...yearResume, response.data]);
            }

            if (url) {
              download(url);
            }
          })
          .catch((err) => console.log(err))
          .finally(() => setGettingYearResume(false));
    },
    [yearResumeFeature, yearResume, view, currentPage]
  );

  const getTaxes = useCallback(
    (
      nAtualizarDarfsPassadas?: boolean,
      nAtualizarIrrf?: boolean,
      atualizouImpostoAcumulado?: boolean,
      nAtualizarPrejuizosAcumulados?: boolean
    ) => {
      !view && setLoading(true);
      !view &&
        (currentPage?.api || apis)
          .get(transactionFeature.apiUrl, {
            params: {
              month: month + 1,
              year,
              nAtualizarDarfsPassadas: nAtualizarDarfsPassadas || false,
              nAtualizarIrrf: nAtualizarIrrf || false,
              atualizouImpostoAcumulado: atualizouImpostoAcumulado || false,
              nAtualizarPrejuizosAcumulados:
                nAtualizarPrejuizosAcumulados || false,
            },
          })
          .then((response) => {
            if (response.data.memoriaCalculo) {
              setData({
                ...response.data,
                multa: response.data.multaAux,
                juros: response.data.jurosAux,
                impostoDevido: response.data.impostoTotal,
                memoriaCalculo: response.data.memoriaCalculo.map(
                  (memoCalc: any) => ({
                    ...memoCalc,
                    date: moment(memoCalc.date.slice(0, 10)).format(
                      "DD/MM/YYYY"
                    ),
                    originalDate: memoCalc.date,
                    market:
                      memoCalc.market === "Opção de Compra" ||
                        memoCalc.market === "Opção de Venda"
                        ? "Mercado de opções"
                        : memoCalc.market,
                  })
                ),
              });
            }
            // setNotAuthorized(false);
          })
          .catch((err) => {
            setData(defaultDarfBolsa);
            if (err?.response?.data === "NOT_AUTHORIZED") {
              // setNotAuthorized(true);
              setShowNotAuthorizedModal(true);
            } else {
              // setNotAuthorized(false);
              message.error(errorMessage);
            }
          })
          .finally(() => setLoading(false));
    },
    [month, year, transactionFeature, view, currentPage]
  );

  const handleDarf = () => {
    setEmitting(true);
    onCloseDarfModal();
    (currentPage?.api || apis)
      .post(taxFeature.apiUrl, {
        ...data,
        memoriaCalculo: [],
        transactions: data.memoriaCalculo,
        totalImpostoDevido: data.impostoTotalFinal,
        impostoDevido: data.impostoTotal,
        juros: data.jurosAux,
        multa: data?.multaAux,
        year,
        month: month + 1,
        name: user.user.name,
        insertPix: true,
        paymentInfo: {
          clientInfo: {
            name: user?.user?.name,
            email: user?.user?.email,
            document: user?.user?.cpf,
          },
        },
      })
      .then((res) => {
        setData((data) => ({ ...data, emitted: true }));
        getYearResume(year, true, res.data.darfUrl);
        setEmitting(false);
        registerFreeAction();
        navigate(
          item.settings?.historicUrl ?? `/${currentBroker.path}/historic`,
          {
            state: { year },
          }
        );
      })
      .catch((err) => {
        message.error(err.response?.data?.message || errorMessage);
        setEmitting(false);
      });
  };

  const registerFreeAction = () => {
    if (user.user.userPlanInfoVelotax.active) return;
    apiPayment
      .put(
        "/user-plan/action",
        {},
        { headers: { "x-api-provider": "crypto-mynt" } }
      )
      .then(() => {
        updateUserInfo();
      })
      .catch(() => {
        message.error("Ocorreu um erro tente novamente");
      });
  };

  const handleRegularize = (regular: boolean) => {
    setEmitting(true);
    (currentPage?.api || apis)
      .post("transaction/regularize", {
        year,
        month: month + 1,
        regular,
        impostoAcumulado:
          (data.impostoTotal ?? 0) + (data.impostoAcumulado ?? 0),
      })
      .then((res) => {
        getYearResume(year, true, res.data.darfUrl);
        getTaxes(false, false, false, true);
        message.success("Dados salvos");
        handleNavigateToHistoric();
      })
      .catch(() => message.error(errorMessage))
      .finally(() => setEmitting(false));
  };

  const onChangeMonth = (value: moment.Moment | null, dateString: string) => {
    const [month, year] = dateString.split("-");
    setMonth(parseInt(month) - 1);
    setYear(parseInt(year));
  };

  const unsetAsset = () => {
    setAsset(undefined);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    unsetAsset();
  };

  const handleCloseAssetModal = () => {
    setShowAssetModal(false);
    unsetAsset();
  };

  const onCloseHelpModal = () => {
    setHelpModal(undefined);
  };

  const onCloseDarfModal = () => {
    setDarfModal(undefined);
  };

  const handleOpenDarfModal = () => {
    setDarfModal(DarfModal(emitted, onCloseDarfModal, handleDarf));
  };

  const handleOpenPaymentModal = () => {
    setPaymentModal(!paymentModal);
  };

  const handleAdd = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    setShowAssetModal(true);
  };

  const handleEdit = (item: any, index: number) => {
    setShowAssetModal(true);
    setAsset({
      ...item,
      id: item._id,
      feeB3: item.fee,
      price: item.sellPrice,
      avgBuyPrice: item.buyPrice,
      data: moment.utc(item.date.toLocaleString()).format("DD/MM/YYYY"),
    });
  };

  const handleRemove = (item: any, index: number) => {
    setShowDeleteModal(true);
    setAsset(item);
  };

  const addAsset = (asset: any) => {
    setLoading(true);
    (currentPage?.api || apis)
      .post(transactionFeature.apiUrl, {
        ...asset,
        operation: "V",
        avgSellPrice: asset.price,
        totalValue: asset.price * asset.quantity,
      })
      .then(() => {
        getTaxes(true, false, false, true);
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseAssetModal();
      });
  };

  const editAsset = (asset: any) => {
    setLoading(true);
    (currentPage?.api || apis)
      .put(`${transactionFeature.apiUrl}/${asset.id}`, {
        ...asset,
        operation: "V",
        avgSellPrice: asset.price,
        totalValue: asset.price * asset.quantity,
      })
      .then(() => {
        getTaxes(true, false, false, true);
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseAssetModal();
      });
  };

  const removeAsset = () => {
    setLoading(true);
    (currentPage?.api || apis)
      .delete(`${transactionFeature.apiUrl}/${asset.id ?? asset._id}`)
      .then(() => {
        getTaxes(true, false, false, true);
        getYearResume(year, true);
      })
      .catch(() => message.error(errorMessage))
      .finally(() => {
        setLoading(false);
        handleCloseDeleteModal();
      });
  };

  const handleNavigateToHistoric = () => {
    navigate(item.settings?.historicUrl ?? `/${currentBroker.path}/historic`, {
      state: { month, year },
    });
  };

  const handleNavigateToIntegration = () => {
    navigate(
      item.settings?.integrationPath ?? `/${currentBroker.path}/integration`
    );
  };

  /* Manipular as tabs de imposto no mobile */
  const [tab, setTab] = useState(1);
  const bolsaOperationsRef = useRef<HTMLDivElement>(null);

  const handleNext = () => {
    setTab((tab) => tab + 1);
    const span = document.querySelector("div.sub-header > span.show");
    bolsaOperationsRef.current?.scrollBy({ left: span?.clientWidth ?? 155 });
  };

  const handlePrev = () => {
    setTab((tab) => tab - 1);
    const span = document.querySelector("div.sub-header > span.show");
    bolsaOperationsRef.current?.scrollBy({ left: -(span?.clientWidth ?? 155) });
  };
  /* Fim da manipulação das tabs de imposto no mobile */

  /* Editar prejuízo acumulado */
  const [resetedPreju, setResetedPreju] = useState(false);
  const [showPrejuModal, setShowPrejuModal] = useState(false);

  const preju = useMemo(
    () => ({
      userPrejuizoComum: resetedPreju
        ? data.prejuizoComum
        : data.userPrejuizoComum ?? data.prejuizoComum,
      userPrejuizoDayTrade: resetedPreju
        ? data.prejuizoDayTrade
        : data.userPrejuizoDayTrade ?? data.prejuizoDayTrade,
      userPrejuizoFII: resetedPreju
        ? data.prejuizoFII
        : data.userPrejuizoFII ?? data.prejuizoFII,
    }),
    [data, resetedPreju]
  );

  // const handleResetPreju = () => {
  //   setResetedPreju(true);
  // };

  const handleEditPreju = () => {
    setResetedPreju(false);
    setShowPrejuModal(true);
  };

  const handleClosePrejuModal = () => {
    setShowPrejuModal(false);
  };

  const editPreju = (data: any) => {
    handleClosePrejuModal();

    (currentPage?.api || apis)
      .put(`${prejuizoFeature.apiUrl}?month=${month + 1}&year=${year}`, data)
      .then((res) => {
        message.success("Dados salvos");
        getTaxes(true, true, false, true);
      })
      .catch(() => {
        message.error(errorMessage);
      });
  };
  /* Fim do editar prejuízo acumulado */

  /* Editar IRRF */
  const [showIrrfModal, setShowIrrfModal] = useState(false);

  const irrf = useMemo(
    () => ({
      userIrrfComum: data.irrfComum,
      userIrrfDayTrade: data.irrfDayTrade,
      userIrrfFII: data.irrfFII,
      userIrrfTotal: data.irrfTotal,
    }),
    [data]
  );

  // const handleResetIrrf = () => {
  //   setResetedIrrf(true);
  // };

  const handleEditIrrf = () => {
    setShowIrrfModal(true);
  };

  const handleCloseIrrfModal = () => {
    setShowIrrfModal(false);
  };

  const editIrrf = (data: any) => {
    handleCloseIrrfModal();
    (currentPage?.api || apis)
      .put(`${irrfFeature.apiUrl}?month=${month + 1}&year=${year}`, data)
      .then((response) => {
        message.success("Dados salvos");
        getTaxes(true, true, false, true);
      })
      .catch(() => {
        message.error(errorMessage);
      });
  };
  /* Fim do editar prejuízo acumulado */

  useEffect(() => {
    getTaxes();
    setImpostoActiveKey("");
    setHistoricoActiveKey("");
  }, [getTaxes, month, year]);

  useEffect(() => {
    if (view && darf) {
      getDarf(darf.id);
    }
  }, [getDarf, view, darf]);

  useEffect(() => {
    getYearResume(year);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const dataToPayment = {
      ...data,
      year,
      month: month + 1,
      name: user.user.name,
      memoriaCalculo: [],
      transactions: data.memoriaCalculo,
    };

    setPaymentData(dataToPayment);
  }, [data.impostoTotalFinal, data, month, user.user.name, year]);

  const handlePlanModal = () => {
    showUserPlanModal(!userPlanModal);
  };

  const handleEventDarfButton = () => {
    !userPlanInfoStatus.active && !userPlanInfoStatus.actionFree
      ? handlePlanModal()
      : handleOpenPaymentModal();
  };

  return (
    <Container className={clsx({ view })}>
      {!view && <Typography.Title level={1}>Emita o seu DARF</Typography.Title>}
      {!view && (
        <Typography.Paragraph>
          <span onClick={handleNavigateToIntegration}>Clique aqui</span> para
          fazer a sua integração com a B3.
        </Typography.Paragraph>
      )}
      <Content className={clsx({ view })}>
        <Space direction="vertical" className="full-width">
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={16}>
              <Typography.Title level={3}>
                <BsCalendar3 />
                {monthsExtended[month]} de {year}
              </Typography.Title>
            </Col>
            {!view && (
              <>
                <Col
                  xs={
                    false && item.settings?.showNavigateToIntegrationButton
                      ? 20
                      : 24
                  }
                  sm={
                    false && item.settings?.showNavigateToIntegrationButton
                      ? 6
                      : 8
                  }
                >
                  <DatePicker
                    size="large"
                    picker="month"
                    format="MM-YYYY"
                    disabled={loading}
                    allowClear={false}
                    inputReadOnly={true}
                    onChange={onChangeMonth}
                    suffixIcon={<BsCalendar3 />}
                    defaultValue={defaultValue}
                    locale={antDatePickerLocale}
                    onPanelChange={(e) => getYearResume(e.year())}
                    getPopupContainer={(target) => target.parentElement!}
                    renderExtraFooter={() =>
                      yearResumeFeature.disabled ? (
                        <></>
                      ) : (
                        <DatePickerExtraFooter />
                      )
                    }
                    disabledDate={(current) =>
                      current &&
                      (current > currentDate.endOf("month") ||
                        current <
                        moment(`${currentBroker.initialYear}-01-01`) ||
                        current < moment(`2020-01-01`))
                    }
                    monthCellRender={(e) => (
                      <DatePickerMonthCell event={e} yearResume={yearResume} />
                    )}
                  />
                </Col>
                {false && item.settings?.showNavigateToIntegrationButton && (
                  <Col xs={4} sm={2}>
                    <Tooltip title="Ir para integrações">
                      <AntButton
                        size="small"
                        type="primary"
                        icon={<AiOutlineApi />}
                        onClick={handleNavigateToIntegration}
                      />
                    </Tooltip>
                  </Col>
                )}
              </>
            )}
            {!view && !notAuthorized && status && (
              <>
                <Typography.Text strong style={{ margin: "0 8px" }}>
                  Situação:
                </Typography.Text>
                <StyledTag
                  className={YearResumeStatusCSSClassEnum[status]}
                  title={YearResumeStatusTextEnum[status]}
                  color={YearResumeStatusColorEnum[status]}
                >
                  {YearResumeStatusTextEnum[status]}
                </StyledTag>
              </>
            )}
            {view && data?.emitted && (
              <Col span={24}>
                <PayTags payed={!!data.payed} />
              </Col>
            )}
          </Row>

          <br />

          <BolsaOperations ref={bolsaOperationsRef}>
            {DarfBolsaTabs(data, { handleEditPreju, view }).map(
              (container, rowIndex) => (
                <div key={rowIndex} className={container.class}>
                  {container.tabs.map((item, colIndex) => (
                    <span
                      key={colIndex}
                      className={
                        colIndex === 0 || tab === colIndex ? "show" : ""
                      }
                    >
                      {rowIndex === 0 && (
                        <AntButton
                          type="text"
                          icon={<GrFormPrevious />}
                          onClick={
                            colIndex === 0 || tab === 1 ? undefined : handlePrev
                          }
                          style={{
                            visibility:
                              colIndex === 0 || tab === 1
                                ? "hidden"
                                : "visible",
                          }}
                        />
                      )}
                      {item.content}
                      {rowIndex === 0 && (
                        <AntButton
                          type="text"
                          icon={<GrFormNext />}
                          onClick={
                            colIndex === 0 || tab === 3 ? undefined : handleNext
                          }
                          style={{
                            visibility:
                              colIndex === 0 || tab === 3
                                ? "hidden"
                                : "visible",
                          }}
                        />
                      )}
                    </span>
                  ))}
                </div>
              )
            )}
          </BolsaOperations>

          <br />

          <Collapse
            ghost
            bordered={false}
            defaultActiveKey={[""]}
            expandIconPosition="right"
            activeKey={historicoActiveKey}
            onChange={(key) => setHistoricoActiveKey(key as string)}
          >
            <Collapse.Panel
              key="1"
              header={
                <Typography.Title level={3}>
                  <BsCalculator />
                  Histórico de vendas
                </Typography.Title>
              }
            >
              {!notAuthorized && !view && (
                <Button
                  color="secondary"
                  variant="contained"
                  className="add"
                  disabled={loading}
                  onClick={handleAdd}
                  startIcon={<PlusOutlined />}
                >
                  Adicionar
                </Button>
              )}
              <List
                loading={loading}
                itemLayout="horizontal"
                dataSource={data.memoriaCalculo?.sort(
                  (a, b) =>
                    new Date(b.originalDate).getTime() -
                    new Date(a.originalDate).getTime()
                )}
                renderItem={(item, index) => (
                  <List.Item
                    actions={
                      notAuthorized || view
                        ? []
                        : [
                          <AntButton
                            type="text"
                            onClick={() => handleEdit(item, index)}
                            icon={<FaRegEdit size={16} />}
                          />,
                          <AntButton
                            type="text"
                            onClick={() => handleRemove(item, index)}
                            icon={<AiOutlineDelete size={16} />}
                          />,
                        ]
                    }
                  >
                    <Skeleton title={false} loading={item.loading} active>
                      <List.Item.Meta
                        title={<strong>{item.code}</strong>}
                        description={
                          <div className="list-description">
                            {/* <div className="market">
                              Op.{" "}
                              {Object.values(TipoOperacao).find(
                                (value) =>
                                  value.toLocaleLowerCase() ===
                                    item.operacao?.toLocaleLowerCase() ?? ""
                              )}{" "}
                              -{" "}
                              {Object.values(TipoMercado).find(
                                (value) =>
                                  value.toLocaleLowerCase() ===
                                    item.market?.toLocaleLowerCase() ?? ""
                              )}
                            </div> */}
                            <div>
                              Data:{" "}
                              {moment(item.date, [
                                "DD/MM/YYYY",
                                "YYYY-MM-DD",
                              ]).format("DD/MM/YYYY")}
                            </div>
                            <div>Quantidade: {item.quantity}</div>
                            <div>
                              Ganho:{" "}
                              <strong>
                                {formatCurrency(item.capitalGain)}
                              </strong>
                            </div>
                            {view && (
                              <>
                                <div>
                                  Compra:{" "}
                                  <strong>
                                    {formatCurrency(item.buyPrice)}
                                  </strong>
                                </div>
                                <div>
                                  Venda:{" "}
                                  <strong>
                                    {formatCurrency(item.sellPrice)}
                                  </strong>
                                </div>
                                <div>
                                  Taxas:{" "}
                                  <strong>{formatCurrency(item.fee)}</strong>
                                </div>
                              </>
                            )}
                          </div>
                        }
                      />
                    </Skeleton>
                  </List.Item>
                )}
              />
            </Collapse.Panel>
          </Collapse>

          <br />

          <Collapse
            ghost
            bordered={false}
            defaultActiveKey={[""]}
            expandIconPosition="right"
            activeKey={impostoActiveKey}
            onChange={(key) => setImpostoActiveKey(key as string)}
          >
            <Collapse.Panel
              key="1"
              header={
                <div className="total-tax-header">
                  <Typography.Title level={3}>
                    <DollarCircleOutlined />
                    Imposto total
                  </Typography.Title>
                  <Typography.Title level={3} className="text-center">
                    {loading ? (
                      <Spin style={{ marginRight: "32px" }} />
                    ) : (
                      formatCurrency(impostoCharge)
                    )}
                  </Typography.Title>
                </div>
              }
            >
              <Descriptions size="small" bordered layout="horizontal">
                {DarfResultDescriptions.map((description) => (
                  <Descriptions.Item
                    span={24}
                    key={description.id}
                    label={description.label(setHelpModal)}
                  >
                    {loading ? (
                      <Spin />
                    ) : description.Component ? (
                      <description.Component
                        data={data}
                        year={year}
                        month={month}
                        loading={loading}
                        setDataBolsa={setData}
                        url={transactionFeature.apiUrl}
                        disabled={!notAuthorized && !view}
                        view={view}
                        valorPrincipal={valorPrincipal}
                        handleEdit={
                          description.id === "irrfTotal"
                            ? handleEditIrrf
                            : undefined
                        }
                        getTaxes={getTaxes}
                      />
                    ) : (
                      formatCurrency(
                        Number(data[description.id as keyof IDarfBolsa] || 0)
                      )
                    )}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Collapse.Panel>
          </Collapse>
        </Space>
        {!notAuthorized && !view && (
          <>
            <Divider />
            <Row justify="end" gutter={[16, 16]} className="column-reverse">
              <Col xs={24} sm={12}>
                <Button
                  fullWidth
                  size="large"
                  color="inherit"
                  variant="contained"
                  disabled={loading || emitting}
                  onClick={handleNavigateToHistoric}
                >
                  Ver no histórico
                </Button>
              </Col>
              {valorPrincipal < minDarfPrice && (
                <Col xs={24} sm={12}>
                  <Tooltip
                    title={
                      <>
                        O valor do imposto devido é menor que{" "}
                        {formatCurrency(minDarfPrice)}. Você não precisa emitir
                        um DARF para este mês. Clique aqui para regularizar este
                        mês.
                      </>
                    }
                  >
                    <Button
                      fullWidth
                      size="large"
                      color="secondary"
                      variant="contained"
                      startIcon={emitting && <LoadingOutlined />}
                      disabled={
                        loading ||
                        emitting ||
                        (month === currentMonth && year === currentYear)
                      }
                      onClick={() => {
                        // if (!userPlanInfoStatus) {
                        //   handlePlanModal();
                        //   return;
                        // }

                        handleRegularize(true);
                      }}
                    >
                      {"Salvar sem emitir DARF"}
                    </Button>
                  </Tooltip>
                </Col>
              )}
              {valorPrincipal >= minDarfPrice && (
                <Col xs={24} sm={12}>
                  <Button
                    fullWidth
                    size="large"
                    color="secondary"
                    variant="contained"
                    startIcon={emitting && <LoadingOutlined />}
                    disabled={
                      loading ||
                      emitting ||
                      (month === currentMonth && year === currentYear)
                    }
                    onClick={
                      // (data.impostoTotalFinal ?? 0) <= maxDarfPrice
                      //   ? handleOpenPaymentModal
                      //   : handleOpenDarfModal
                      () => handleEventDarfButton()
                    }
                  >
                    {/* {(data.impostoTotalFinal ?? 0) <= maxDarfPrice
                    ? "Pagar DARF"
                    : emitted
                    ? "Emitir novo DARF"
                    : taxFeature.buttonLabel} */}
                    {handleLabelButton}
                  </Button>
                </Col>
              )}
            </Row>
          </>
        )}
      </Content>
      <Modal
        footer={null}
        visible={helpModal}
        title={helpModal?.title}
        onCancel={onCloseHelpModal}
      >
        {helpModal?.content}
      </Modal>
      <Modal
        visible={darfModal}
        title={darfModal?.title}
        footer={darfModal?.footer}
        onCancel={onCloseDarfModal}
        zIndex={1001}
      >
        {darfModal?.content}
      </Modal>
      <FormModal
        add={addAsset}
        edit={editAsset}
        itemToEdit={asset}
        visibility={showAssetModal}
        onCancel={handleCloseAssetModal}
        rows={DarfBolsaFormItemRows(month, year)}
        title={asset ? "Editar ativo" : "Adicionar ativo"}
      />
      <FormModal
        add={() => { }}
        edit={editPreju}
        itemToEdit={preju}
        rows={PrejuFormItemRows}
        visibility={showPrejuModal}
        onCancel={handleClosePrejuModal}
        title="Editar prejuízos a compensar"
      >
        {/* <Divider />
        <Row gutter={[16, 16]} align="middle">
          <Col span={24}>
            <Typography>
              Caso altere algum desses valores, você pode voltar aos valores
              calculados automaticamente pelo sistema (clique em aplicar e
              salvar):
            </Typography>
          </Col>
          <Col xs={24} sm={14}>
            <Row>
              <Col span={16}>Prejuízo Comum:</Col>
              <Col span={8}>{formatCurrency(data.prejuizoComum ?? 0)}</Col>
              <Col span={16}>Prejuízo Day Trade:</Col>
              <Col span={8}>{formatCurrency(data.prejuizoDayTrade ?? 0)}</Col>
              <Col span={16}>Prejuízo FII:</Col>
              <Col span={8}>{formatCurrency(data.prejuizoFII ?? 0)}</Col>
            </Row>
          </Col>
          <Col xs={24} sm={10}>
            <Button onClick={handleResetPreju} style={{ marginLeft: "auto" }}>
              Aplicar
            </Button>
          </Col>
        </Row> */}
      </FormModal>
      <FormModal
        add={() => { }}
        edit={editIrrf}
        itemToEdit={irrf}
        rows={IrrfFormItemRows}
        visibility={showIrrfModal}
        onCancel={handleCloseIrrfModal}
        title="Editar IRRF"
      >
        {/* <Divider />
        <Row gutter={[16, 16]} align="middle">
          <Col span={24}>
            <Typography>
              Caso altere algum desses valores, você pode voltar aos valores
              calculados automaticamente pelo sistema (clique em aplicar e
              salvar):
            </Typography>
          </Col>
          <Col xs={24} sm={14}>
            <Row>
              <Col span={16}>IRRF Comum:</Col>
              <Col span={8}>{formatCurrency(data.irrfComum ?? 0)}</Col>
              <Col span={16}>IRRF Day Trade:</Col>
              <Col span={8}>{formatCurrency(data.irrfDayTrade ?? 0)}</Col>
              <Col span={16}>IRRF FII:</Col>
              <Col span={8}>{formatCurrency(data.irrfFII ?? 0)}</Col>
              <Col span={16}>IRRF Total:</Col>
              <Col span={8}>{formatCurrency(data.irrfTotal ?? 0)}</Col>
            </Row>
          </Col>
          <Col xs={24} sm={10}>
            <Button onClick={handleResetIrrf} style={{ marginLeft: "auto" }}>
              Aplicar
            </Button>
          </Col>
        </Row> */}
      </FormModal>
      <PaymentModal
        item={item}
        show={paymentModal}
        emitting={emitting}
        disablePixOption={(data?.impostoTotalFinal || 0) > maxPixPayment}
        disableCreditCardOption={
          (data?.impostoTotalFinal || 0) > maxCreditCardPayment
        }
        onCancel={handleOpenPaymentModal}
        paymentData={{ ...paymentData, impostoTotalFinal: impostoCharge }}
        callDarf={() => handleOpenDarfModal()}
        maxPixValue={maxPixPayment}
        maxCCValue={maxCreditCardPayment}
        selectedYear={year}
      />
      <DeleteConfirmationModal
        showToast={false}
        title="Remover ativo"
        visibility={showDeleteModal}
        onCancel={handleCloseDeleteModal}
        setVisibility={setShowDeleteModal}
        onOk={() => Promise.resolve(removeAsset())}
        body="Você realmente quer deletar esse ativo?"
      />
      <IntegrationModal
        visible={showNotAuthorizedModal}
        onCancel={() => setShowNotAuthorizedModal(false)}
      />

      {!view && (
        <div className="juridic-messages-container">
          <div className="message">
            <p>
              (1) Você tinha investimentos em 31/12/2019 e ainda não preencheu o
              seu custo médio?{" "}
              <span
                onClick={() =>
                  navigate(`/${currentBroker.path}/bolsa-insert-manual`)
                }
                style={{ cursor: "pointer", color: "var(--ant-primary-color)" }}
              >
                Clique aqui
              </span>
            </p>
          </div>
          <div className="message">
            <p>
              (2) As taxas apresentadas incluem somente as tarifas de
              liquidação, registro, termo/opções e emolumentos da B3. Caso
              deseje, você pode adicionar manualmente os custos de corretagem em
              cada operação.
            </p>
          </div>
          <div className="message">
            <p>
              (3) Para preencher automaticamente os seus prejuízos acumulados,
              você deve salvar os meses na ordem do mais antigo para o mais
              recente.
            </p>
          </div>
          <div className="message">
            <p>
              (4) O Usuário é exclusivamente responsável pela conferência e
              validação das informações utilizadas na apuração do imposto
              devido, conforme{" "}
              <a
                rel="noreferrer"
                href="https://velotax-termos-e-condicoes.s3.us-east-1.amazonaws.com/Termos%20de%20Uso%20-%20Velotax%20v1.pdf"
                target="_blank"
              >
                Termos e Condições Gerais de Uso.
              </a>
            </p>
          </div>
        </div>
      )}
    </Container>
  );
};
